import SocialsSection from '@components/company/linkSection';
import PoweredBy from '@components/pimster/poweredBy';
import { GetCompanyQuery } from '@graphql/generated/graphql';
import { useCompanyConfig } from '@lib/config/hooks';
import { VStack } from '@lib/uikit';
import { FC } from 'react';

type Props = {
    company: NonNullable<Unpacked<GetCompanyQuery['companies']>>;
};

const Footer: FC<Props> = ({ company }) => {
    const { whiteLabel } = useCompanyConfig();

    return (
        <VStack spacing='sm' marginBottom='md'>
            <SocialsSection links={company.SocialLinks} />
            {!whiteLabel.product && <PoweredBy />}
        </VStack>
    );
};

export default Footer;
